<template>
    <div class="es-results-pagination">
        <paginate
            v-if="pages.length > 1"
            :value="selectedPage"
            @input="onInput"
            :page-count="pages.length"
            next-class="page-link"
            prev-class="page-link"
            container-class="pagination"
            page-class="page-item"
            page-link-class="page-link">
        </paginate>
    </div>
</template>

<script>
import Paginate from 'vuejs-paginate'

export default {
    name: 'ESResultsPagination',
    components: {
        Paginate
    },
    props: {
        pages: {
            type: Array,
            required: true
        },
        selectedPage: {
            type: Number,
            required: true
        }
    },
    methods: {
        onInput(page) {
            this.$emit('input', page)
        }
    }
}
</script>

<style lang="scss">
.es-results-pagination {
    .pagination {
        margin-bottom: 0;

        .page-link {
            color: $color-purple-light;
            padding: 6px 12px;

            &:hover {
                color: $color-purple-light;
            }
        }

        .page-item.active .page-link {
            background: $color-purple-light;
            border-color: $color-purple-light;
            color: white;
        }

        li:last-of-type {
            border-bottom-right-radius: 3px;
            border-top-right-radius: 3px;
        }

        li:first-of-type {
            border-bottom-left-radius: 3px;
            border-top-left-radius: 3px;
        }
    }
}
</style>
